/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useStudioForm } from './useStudioForm';
import { Sanitize } from '../../../Components/Sanitizer/index';
import SelectField from '../../../Components/FormFields/SelectField';
import StudioFormSkeleton from './StudioFormSkeleton';

/**
 * StudioForm Component
 * @param props
 * @returns {Element}
 * @constructor
 */
export default function StudioForm(props) {
  const {
    firstStepContent, studioWhitelist, resetValidSteps, formField: { studioId, formOfTraining }, context, sitePackage,
  } = props;
  const {
    isLoading, studios, resetAppointmentOnStudioChange, resetAppointmentOnTypeChange,
  } = useStudioForm(context, sitePackage, studioWhitelist, resetValidSteps);

  /**
     * the dom section which will be loaded with a skeleton as loading indicator
     * @return {JSX.Element}
     */
  const renderFormElements = () => {
    // While loading return the loading overlay
    if (isLoading) {
      return <StudioFormSkeleton />;
    }

    return (
      <>
        <Grid item xs={12}>
          <SelectField
            name={studioId.name}
            label={studioId.label}
            data={studios}
            onChange={resetAppointmentOnStudioChange}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12}>
          <SelectField
            name={formOfTraining.name}
            label={formOfTraining.label}
            data={formOfTraining.data}
            onChange={resetAppointmentOnTypeChange}
            fullWidth
            required
          />
        </Grid>
      </>
    );
  };

  return (
    <>
      <Sanitize value={firstStepContent} />
      <Grid container spacing={3}>
        {renderFormElements()}
      </Grid>
    </>
  );
}

StudioForm.propTypes = {
  firstStepContent: PropTypes.object.isRequired,
  studioWhitelist: PropTypes.array.isRequired,
  resetValidSteps: PropTypes.func.isRequired,
  formField: PropTypes.object.isRequired,
  context: PropTypes.string.isRequired,
  sitePackage: PropTypes.string.isRequired,
};
